import regexDictionary from 'scripts/regexDictionary'

const passwordValidations = 
{
    1: {text: "Contiene números", validate: (value)=> !value.toString().match(regexDictionary.passwordRegex.containNumbers)},
    2: {text: "Contiene al menos una minúscula y una mayúscula", validate: (value) => !value.toString().match(regexDictionary.passwordRegex.containLetters)},
    3: {text:  "Mínimo 6 caracteres", validate: (value) => !value.toString().match(regexDictionary.length(6,20))}
}

export default passwordValidations